
import {RADIO_SINGLE_RANDOM_VALUE, RadioButton} from "../prm/radio-button";
import {Name} from "../prm/name";
import {OptionMenu} from "../prm/option-menu";

const invest_start_amt = "invest_start_amt";

const contribute_yes_no = "contribute_yes_no";

const contribute_cadence = "contribute_cadence";

const contribute_amt = "contribute_amt";

// Number of years for running the portfolio
const ACCESS_FUNDS_YEARS_NAME = new Name("access_funds_years");

// Number of years for dispersing the portfolio
const SPEND_FUNDS_YEARS_NAME = new Name("spend_funds_years");

const ROLE_0_SOURCE_OF_FUNDS = new Name("role_0_source_of_funds");
const ROLE_0_OTHER_SOURCE = new Name("role_0_other_source");
const ROLE_1_SOURCE_OF_FUNDS = new Name("role_1_source_of_funds");
const ROLE_1_OTHER_SOURCE = new Name("role_1_other_source");

const AllNames = {
  invest_start_amt,
  contribute_yes_no,
  contribute_cadence,
  contribute_amt,
  ACCESS_FUNDS_YEARS_NAME,
  SPEND_FUNDS_YEARS_NAME,
  ROLE_0_SOURCE_OF_FUNDS,
  ROLE_0_OTHER_SOURCE,
  ROLE_1_SOURCE_OF_FUNDS,
  ROLE_1_OTHER_SOURCE,
};

const ROLLOVER_IRA_TEXT_2 = "Roll over a 401k, a SIMPLE or a SEP";

const INVEST_FOR_INDEX = {
  transfer: 0,
  standard_invest_0: 1,
  IRA: 2,
  IRA_rollover: 3,
  trust: 4,
  standard_invest_1: 5,
}

const INVEST_FOR = new RadioButton(
  new Name("invest_for"),
  [
    new Name("transfer", "Transfer an account from another firm"),
    new Name("standard_invest_0", "Open up a long term investment account"),
    new Name("IRA", "Start an Individual Retirement Account"),
    new Name("IRA_rollover", ROLLOVER_IRA_TEXT_2),
    new Name("trust", "Set up an account for a child"),
    new Name("standard_invest_1", "Put some money in the markets"),
  ], [], RADIO_SINGLE_RANDOM_VALUE);

const INVEST_TYPE = new OptionMenu(
  new Name("invest_type"),
  [
    new Name("individual", "Individual"),
    new Name("spouse", "Spouse"),
  ]);

const IRA_TYPE = new RadioButton(
  new Name("ira_type"),
  [
    new Name("traditional", "Traditional IRA"),
    new Name("roth", "Roth IRA"),
  ]);

const CREATE_SOURCE_OF_FUNDS_PRM = prm_name => {
  return new RadioButton(
    prm_name,
    [
      new Name("salary", "Employment/Wages"),
      new Name("inheritance", "Inheritance/Trust"),
      new Name("lottery", "Lottery/Gambling"),
      new Name("retirement", "Retirement Funds"),
      new Name("investments", "Investments"),
      new Name("spouse", "Spousal/Parental Support"),
      new Name("gift", "Gift"),
      new Name("unemployment", "Unemployment/Disability"),
      new Name("savings", "Savings"),
      new Name("settlement", "Legal Settlement"),
      new Name("other", "Other"),
    ]);
}

export { AllNames, INVEST_TYPE, INVEST_FOR, INVEST_FOR_INDEX, IRA_TYPE,
  CREATE_SOURCE_OF_FUNDS_PRM };
